/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { SearchInput } from "~/components";
import { maxSearchLength, searchDelay } from "~/components/SearchInput/const";
import { useSleep } from "~/hooks";
import { ResourceDetailsActionDetailsSidebarHeaderDownload } from "./ResourceDetailsActionDetailsSidebarHeaderDownload";
import { ResourceDetailsActionDetailsSidebarHeaderFilters } from "./ResourceDetailsActionDetailsSidebarHeaderFilters";
import { useResourceDetailsActionDetailsState } from "./ResourceDetailsActionDetailsSidebarProvider";

const minSearchLength = 1;

type Props = {
  eventId: string;
  eventActionId: string;
  resourceId: string;
};

export function ResourceDetailsActionDetailsSidebarHeader({
  eventId,
  eventActionId,
  resourceId,
}: Props) {
  const { updateActionDetailsState } = useResourceDetailsActionDetailsState();
  const { sleep, cancelSleep } = useSleep();

  const onChange = async (query: string) => {
    cancelSleep();
    if (query.length !== 0) {
      await sleep(searchDelay);
    }
    updateActionDetailsState({ searchQuery: query });
  };

  return (
    <Box mb={theme.spacing.spacing04}>
      <FlexContainer mb={theme.spacing.spacing04}>
        <div css={{ flex: 1, marginRight: theme.spacing.spacing04 }}>
          <SearchInput
            placeholder="Type a Keyword"
            onSubmit={(query) => {
              cancelSleep();
              updateActionDetailsState({ searchQuery: query });
            }}
            onChange={onChange}
            minLength={minSearchLength}
            maxLength={maxSearchLength}
          />
        </div>
        <ResourceDetailsActionDetailsSidebarHeaderDownload
          eventId={eventId}
          eventActionId={eventActionId}
          resourceId={resourceId}
        />
      </FlexContainer>
      <ResourceDetailsActionDetailsSidebarHeaderFilters
        eventId={eventId}
        eventActionId={eventActionId}
        resourceId={resourceId}
      />
    </Box>
  );
}
